import React from 'react';
import "../css/Loader.css";
import LoaderImage from "../assets/Infinity@1x-1.0s-200px-200px.svg"

function Loader() {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        <img src={LoaderImage} alt="Loading..." className="loader-image" />
      </div>
    </div>
  );
}

export default Loader;
